import React from 'react';
import PropTypes from 'prop-types';
import styles from './InfoMessage.module.css';
import Alert from  '@mui/material/Alert';

function InfoMessage(props) {

    const { type, closeHandler, message } = props;
    const styleClass = type === "error" ? styles.Error : styles.Info;

    if (!message || message.trim() === "") return null;

    return (
        <Alert 
            severity={type ? type : "warning"} 
            onClose={closeHandler ? closeHandler : null}
            className={[styles.InfoMessage, styleClass].join(" ")}
        > 
            { message } 
        </Alert>
    )
}

InfoMessage.propTypes = {
    type: PropTypes.string,
    closeHandler: PropTypes.func,
    message: PropTypes.string.isRequired,
}

export default InfoMessage

